import { Directive, ElementRef, OnInit, OnDestroy, Input } from '@angular/core';
import { main } from '@core/operators';

const GROUPS: { [name: string]: UniformDirective[] } = {};


@Directive({
  selector: '[uniform]'
})
export class UniformDirective implements OnInit, OnDestroy {

  private options: UniformOptions;
  private element: HTMLElement = this.ref.nativeElement;
  private default: { width: number, height: number };

  private static render(group: string) {
   
    main(() => {

      if (!GROUPS[group]) return;
      let max = { width: 0, height: 0 };

      GROUPS[group]
        .commit(i => {

          if (i.default && max.width < i.default.width) max.width = i.default.width;
          if (i.default && max.height < i.default.height) max.height = i.default.height;
        })
        .commit(i => {

          if (i.options && i.options.width) i.element.style.width = max.width + 'px';
          if (i.options && i.options.height) i.element.style.height = max.height + 'px';
        });
    });
  }

  private observer = new MutationObserver(() => {

    if (this.options && this.options.group && GROUPS[this.options.group]) {

      main(() => {
        if (this.options && this.options.width) this.element.style.removeProperty('width');
        if (this.options && this.options.height) this.element.style.removeProperty('height');

        let rect = this.element.getBoundingClientRect();
        this.default = { width: rect.width, height: rect.height };
      });

      UniformDirective.render(this.options.group);
    }
  });

  @Input() public set uniform(options: UniformOptions) {
    if (options != this.options) {
      if (this.options && this.options.group) {
        GROUPS[this.options.group].remove(this);
        if (GROUPS[this.options.group].length < 1) {
          delete GROUPS[this.options.group];
        }
        else {
          UniformDirective.render(this.options.group);
        }
      }

      this.options = options;

      if (this.options && this.options.group) {
        if (!GROUPS[this.options.group]) GROUPS[this.options.group] = [];
        GROUPS[this.options.group].push(this);
      }
    }
  }

  public get uniform() {
    return this.options;
  }

  constructor(private ref: ElementRef) {
  }

  ngOnInit() {
    this.observer.observe(this.ref.nativeElement, { subtree: true, characterData: true });
  }

  ngOnDestroy() {
    this.uniform = null;
    this.observer.disconnect();
  }
}

export interface UniformOptions {
  group: string;
  width?: boolean;
  height?: boolean;
}
